import * as React from 'react';
const SvgAddWaypointIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    viewBox={'0 0 36 36'}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || 'currentColor'}
      fillRule="evenodd"
      d="M31.687 8.916a14.25 14.25 0 0 1 1.18 5.7h-.003c0 2.838-.678 5.656-2.019 8.374-1.072 2.187-2.569 4.323-4.456 6.346-3.223 3.46-6.603 5.576-7.562 6.142a1.765 1.765 0 0 1-1.798 0c-.958-.566-4.338-2.682-7.562-6.142-1.887-2.027-3.384-4.158-4.456-6.346C3.678 20.268 3 17.446 3 14.612c0-1.975.397-3.894 1.18-5.7a14.606 14.606 0 0 1 3.208-4.644 14.961 14.961 0 0 1 4.745-3.123 15.117 15.117 0 0 1 5.8-1.144c2.011 0 3.962.385 5.801 1.148a14.899 14.899 0 0 1 4.745 3.123 14.552 14.552 0 0 1 3.208 4.644m-12.248 4.78h3.375c.176 0 .321.144.321.321v2.25a.322.322 0 0 1-.321.322h-3.375v3.375a.323.323 0 0 1-.322.321h-2.25a.322.322 0 0 1-.321-.321v-3.375h-3.375a.323.323 0 0 1-.321-.322v-2.25c0-.176.144-.321.321-.321h3.375v-3.375c0-.176.145-.321.321-.321h2.25c.177 0 .322.144.322.321z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAddWaypointIcon;
